

// trigger the course detail modal on elements with class .course-link
export default function courseLinkDir(capsService, $uibModal, $timeout, $filter) {
    var courseLink = {
        restrict: 'A',
        modalTemplate: `
            <div class="modal-header d-flex justify-content-between">
                <h3 class="modal-title" id="update-modal-label">{{::modal.code}}<br />{{::modal.course.name}}</h3>               
            </div>
            <div class="modal-body">
                <div ng-if="modal.course.date" class="alert mb-3">
                    <i class="fal fa-comment-alt-exclamation"></i>
                    <div>
                        <p>This content was archived on {{::modal.course.date}} and is no longer updated.</p>
                    </div>
                </div>
                <p ng-bind-html="modal.description"></p>
                <dl class="dl-columns">
                    <dt>Offered</dt>
                    <dd>
                        <ul class="list-unstyled" ng-if="modal.course.locations.length">
                            <li ng-repeat="o in modal.course.locations track by $index">
                                <strong>{{o.campus}}</strong>: {{modal.value(o)}}
                            </li>
                        </ul>
                        <span ng-if="!modal.course.locations.length">Not currently offered</span>
                    </dd>
                    <dt>Units</dt>
                    <dd>{{::modal.course.units}}</dd>
                    <dt>Prerequisites</dt>
                    <dd>{{::modal.course.prerequisites || 'None'}}</dd>
                    <dt>Corequisites</dt>
                    <dd>{{::modal.course.corequisites || 'None'}}</dd>
                    <dt>Antirequisites</dt>
                    <dd>{{::modal.course.antirequisites || 'None'}}</dd>
                </dl>
            </div>
            <div class="modal-footer p-2">
                <a role="button" href="{{::modal.course.url}}" class="btn btn-primary mr-auto">
                    <span ng-if="!modal.course.date">Course detail</span>
                    <span ng-if="modal.course.date">Current version</span>
                </a>
                <button class="btn btn-outline-primary" ng-click="modal.cancel()">Close</button>
            </div>`,
        link: link
    };

    function link(scope, element, attrs) {
        var t;
        element.bind('click', function (e) {

            e.preventDefault();
            if (!t) {
                t = $timeout(function () {
                    var code = attrs.code,
                        number = attrs.number,
                        date = attrs.date;

                    if (date !== undefined) {
                        capsService.getArchivedCourse(code + '-' + number, date)
                            .then(function (r) {
                                showModal(r.data.data, date);
                                $timeout.cancel(t);
                                t = undefined;
                            });
                    }
                    else {
                        capsService.getCourse(code + number)
                            .then(function (r) {
                                showModal(r.data.data);
                                $timeout.cancel(t);
                                t = undefined;
                            });
                    }
                }, 200);
            }
        });

        function showModal(course, ticks) {

            if (ticks) {
                course.date = $filter('date')(new Date(parseInt(ticks)), 'EEEE, d MMMM yyyy');
            }

            var modalInstance = $uibModal.open({
                template: courseLink.modalTemplate,
                controller: 'courseModalController as modal',
                windowClass: 'course-detail-modal',
                resolve: {
                    course: function () {
                        return course;
                    }
                }
            });
        }
    }

    return courseLink;
};
